import { remove } from 'diacritics';

export const normalizeString = (string: string) => {
    const ret = remove(string).replace(" ", "+");
    console.log(ret);
    return ret;
}